// The backend's KYC timestamps are UTC. Older ones were written without a zone
// ("2026-10-15T05:57:00"), which a browser reads as local (India) time — 5½ hours
// early. Read a date-time with no zone as UTC; dates, and times that carry a zone
// ("…Z", "…+05:30"), are left as they are.
export const parseServerTime = (ts?: string | null): Date => {
    const s = String(ts ?? '');
    const naive = /T\d{2}:\d{2}/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(s);
    return new Date(naive ? `${s}Z` : s);
};
